export enum PostRoomStatePromptType {
  blindSpot = 'blind_spot',
  nailed = 'nailed',
  professorFeedback = 'professor_feedback',
  sentimentAnalysis = 'sentiment_analysis',
  summarize = 'summarize',
  surprisingTurn = 'surprising_turn',
}

// convenience data types as enums are a nightmare to work dynamically with in JS
export const PostRoomStatePromptTypeMap = {
  blind_spot: PostRoomStatePromptType.blindSpot,
  nailed: PostRoomStatePromptType.nailed,
  professorFeedback: PostRoomStatePromptType.professorFeedback,
  sentimentAnalysis: PostRoomStatePromptType.sentimentAnalysis,
  summarize: PostRoomStatePromptType.summarize,
  surprisingTurn: PostRoomStatePromptType.surprisingTurn,
}

export const PostRoomStatePromptTypeReverseMap = {
  [PostRoomStatePromptType.blindSpot]: 'blind_spot',
  [PostRoomStatePromptType.nailed]: 'nailed',
  [PostRoomStatePromptType.professorFeedback]: 'professor_feedback',
  [PostRoomStatePromptType.sentimentAnalysis]: 'sentiment_analysis',
  [PostRoomStatePromptType.summarize]: 'summarize',
  [PostRoomStatePromptType.surprisingTurn]: 'surprising_turn',
}

export const PostRoomStatePromptTypeList = [
  PostRoomStatePromptType.blindSpot,
  PostRoomStatePromptType.nailed,
  PostRoomStatePromptType.professorFeedback,
  PostRoomStatePromptType.sentimentAnalysis,
  PostRoomStatePromptType.summarize,
  PostRoomStatePromptType.surprisingTurn,
]

export const PostRoomStatePromptTypeNames = Object.keys(
  PostRoomStatePromptTypeMap
)
